(() => {
  if (window.ptbSliderVideoLoader) return;
  window.ptbSliderVideoLoader = true;
  const hydrate = host => {
    const video = host.querySelector('video');
    const source = video && video.querySelector('source[data-src]');
    if (!source || !source.dataset.src) return;
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
    video.preload = 'metadata';
    video.load();
    host.loaded = true;
  };
  const hydrateSection = section => {
    section.querySelectorAll('[data-lazy-slider-video]').forEach(hydrate);
  };
  const observed = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      hydrateSection(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '300px 0px', threshold: 0 }) : null;
  const init = root => {
    root.querySelectorAll('[data-lazy-slider-video]').forEach(host => {
      const section = host.closest('[id^="shopify-section-"]');
      if (!section || observed.has(section)) return;
      observed.add(section);
      if (observer) observer.observe(section);
    });
  };
  // Capture runs before Shrine's existing play-button listener.
  document.addEventListener('click', event => {
    const button = event.target.closest('.internal-video__play');
    const host = button && button.closest('[data-lazy-slider-video]');
    if (host) hydrate(host);
  }, true);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (observer) observer.unobserve(event.target);
  });
})();
